export default __webpack_public_path__ + "locales/sr-Latn-RS/Translations.json?hash=70404cf83bcb1ece7573106a3797fef8";